import { supabase } from '@/lib/supabase';
import { toDashboardUiError } from '@/lib/dashboard-errors';
import type {
  ToolActionRequest,
  ToolActionResponse,
  ToolActionStatus,
} from '@shared/types/tool-actions';

const TOOL_ACTION_STATUSES: ToolActionStatus[] = [
  'needs_confirmation',
  'completed',
  'partially_completed',
  'already_done',
  'needs_connection',
  'missing_info',
  'failed',
];

const isRecord = (value: unknown): value is Record<string, unknown> => (
  typeof value === 'object' && value !== null && !Array.isArray(value)
);

const isToolActionResponse = (value: unknown): value is ToolActionResponse => (
  isRecord(value)
  && TOOL_ACTION_STATUSES.some((status) => status === value.status)
  && (
    value.actionKey === 'gmail.create_draft'
    || value.actionKey === 'sales.sync_people_to_crm'
    || value.actionKey === 'sales.apply_crm_outcome'
    || value.actionKey === 'domino.apply_contextual_action'
  )
  && typeof value.label === 'string'
  && typeof value.message === 'string'
  && (value.confirmationId === undefined || value.confirmationId === null || typeof value.confirmationId === 'string')
  && (value.preview === undefined || value.preview === null || isRecord(value.preview))
  && (value.externalUrl === undefined || value.externalUrl === null || typeof value.externalUrl === 'string')
);

export const invokeToolAction = async (
  request: ToolActionRequest,
): Promise<ToolActionResponse> => {
  const { data, error } = await supabase.functions.invoke('tool-action', {
    body: request,
  });

  if (error) {
    throw await toDashboardUiError(error, 'Impossible d’exécuter cette action.');
  }

  if (!isToolActionResponse(data)) {
    throw new Error('Réponse invalide de tool-action.');
  }

  return data;
};
